import { Injectable } from '@angular/core';
import {
  collection,
  collectionData,
  Firestore,
  getDocs,
  orderBy,
  query,
  where,
} from '@angular/fire/firestore';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  constructor(private readonly firestore: Firestore) {}

  getPaymentsByDocId(id: string) {
    const paymentsRef = collection(this.firestore, 'payments');
    const q = query(
      paymentsRef,
      where('productDocId', '==', id),
      where('confirmed', '==', true),
      where('productType', '==', 'livestream')
    );

    return collectionData(q).pipe(
      map((changes) => changes.map((a) => ({ docId: a.docId, ...a as Record<string, unknown> })))
    );
  }

  getPaymentsTypeLiveStream(dateRange: { fromDate: string; toDate: string }) {
    const paymentsRef = collection(this.firestore, 'payments');
    const q = query(
      paymentsRef,
      orderBy('createdTime', 'asc'),
      where('createdTime', '>=', new Date(dateRange.fromDate)),
      where('createdTime', '<=', new Date(dateRange.toDate))
    );

    return collectionData(q).pipe(
      map((changes) => changes.map((a) => ({ docId: a.docId, ...(a as Record<string, unknown>) })))
    );
  }

  async getPaymentsByLiveStreamGroupDocId(
    id: string
  ): Promise<Record<string, string>[]> {
    const paymentsRef = collection(this.firestore, 'payments');
    const q = query(
      paymentsRef,
      where('productDocId', '==', id),
      where('confirmed', '==', true),
      where('productType', '==', 'livestreamGroup')
    );

    const snapshot = await getDocs(q);
    return snapshot.docs.map((doc) => ({
      docId: doc.id,
      ...(doc.data() as Record<string, string>),
    }));
  }
}
